/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const baby_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.604 17.684c-1.762 1.992-4.945 1.992-6.708 0M14.738 1c3.676 2.468 1.8 8.46-2.61 8.34-2.024-.056-3.69-1.478-4.239-3.417m0 0a8.904 8.904 0 0 1 4.361-1.139c3.962 0 7.459 2.62 8.611 6.454 1.436 0 2.639 1.196 2.639 2.654s-1.203 2.654-2.639 2.654C19.709 20.38 16.212 23 12.25 23c-3.962 0-7.459-2.62-8.611-6.454C2.203 16.546 1 15.35 1 13.892s1.203-2.654 2.639-2.654a9.075 9.075 0 0 1 4.25-5.315Zm.934 8.084h.346m5.652 0h.346m-5.919 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm5.998 0c0 .183-.16.243-.248.243-.091 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default baby_medium
